import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { SESSION_MGMT_DOMAIN } from 'core/constants/endpoints'

import { SessionMgmtDTO } from './types'

const sanitize = session => {
  const keysToString = ['user', 'browser', 'quote']
  const sanitized = { ...session }

  for (const key of keysToString)
    if (sanitized[key])
      for (const subKey in sanitized[key])
        if (sanitized[key][subKey]) {
          sanitized[key][subKey] = `${sanitized[key][subKey]}`
        }

  return sanitized
}

export default function save(data: SessionMgmtDTO) {
  const url = `${SESSION_MGMT_DOMAIN}/api/v1/session`

  return fetchJSONHandleError({
    url,
    data: sanitize(data)
  })
}
